import React from 'react';
import { connect } from 'react-redux';
import { startLogin } from '../actions/auth';

export const LoginPage = ({ startLogin }) => (
  <div className='box-layout'>
  <div className='box_layout__box'>
    <h1 className='box_layout__title'><img src='/images/images.jpg'></img></h1>
    <p>माहेश्वरी प्रगति मंडल, सोलापुर</p>
    <button onClick={startLogin} className='button'>Login with Google</button>
  </div>
  </div>
);

const mapDispatchToProps = (dispatch) => ({
  startLogin: () => dispatch(startLogin())
});

export default connect(undefined, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/LoginPage.js